export default {
    state: {
        list: null,

        count: null,

        timeZones: null,

        filters: {
            search: "",
            users: [],
        },

        controllers: {
            list: null
        },

        categories: []
    },

    mutations: {
        LOCALS_SET_LIST(state, list) {
            state.list = list;
        },

        LOCALS_SET_COUNT(state, count) {
            state.count = count;
        },

        LOCALS_SET_TIMEZONES(state, timeZones) {
            state.timeZones = timeZones;
        },

        LOCALS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },
        SET_LOCALS_LIST(state, list) {
            state.list = list;
        },

        LOCALS_RESET_FILTERS(state) {
            state.filters = {
                search: "",
                users: [],
            };
        },

        LOCALS_SET_CONTROLLERS_LIST(state, list) {
            state.controllers.list = list;
        },

        LOCALS_SET_CATEGORIES(state, list) {
            state.categories = list;
        },
    },
};
